import React, { useEffect, useRef, useState } from "react";
import { API } from "aws-amplify";
import { GET_CHECKLIST_FOR_EQUIPMENT } from "../../gql/bookingapi";
import { REPO_CONFIG } from "../../constants";
import { configureAwsAppSync } from "../../utils/helpers/configureAwsAppSync";
import ChecklistFolder from "../../icons/ChecklistFolder";
import { getFieldValue } from "../booking-instruments/helpers";

const REPOSITORY_URL = process.env.REACT_APP_REPOSITORY_URL || "";

export const checklistCache = new Map();

const resolveField = (data, snakeKey, camelKey) =>
  getFieldValue(data, snakeKey) ||
  getFieldValue(data?.equipment, camelKey) ||
  getFieldValue(data, camelKey);

export const fetchDocumentationStatus = async ({ model, site, group }) => {
  const cacheKey = `${site}#${group}#${model}`;
  const cached = checklistCache.get(cacheKey);
  if (cached !== undefined) {
    return cached;
  }

  try {
    configureAwsAppSync({ aws_appsync_graphqlEndpoint: REPO_CONFIG.aws_appsync_graphqlEndpoint });
    const result = await API.graphql({
      query: GET_CHECKLIST_FOR_EQUIPMENT,
      variables: { input: { model, site, group } },
    });
    const items = result?.data?.getChecklistsForEquipment?.items || [];
    checklistCache.set(cacheKey, items);
    return items;
  } catch (error) {
    console.warn("Documentation fetch failed:", error);
    checklistCache.set(cacheKey, []);
    return [];
  }
};

const ChecklistRender = (params) => {
  const [hasChecklists, setHasChecklists] = useState(false);
  const [loading, setLoading] = useState(false);
  const checkedRef = useRef(false);

  const { data } = params || {};
  const inventoryId = getFieldValue(data, "id") || data?.id;
  const model = resolveField(data, "equipment_model", "equipmentModel");
  const site = resolveField(data, "site_name", "siteName");
  const group = resolveField(data, "belonging_to_group", "belongingToGroup");

  useEffect(() => {
    if (checkedRef.current || !model || !site || !group) {
      return;
    }
    checkedRef.current = true;

    const fetchData = async () => {
      try {
        setLoading(true);
        const items = await fetchDocumentationStatus({ model, site, group });
        setHasChecklists(items.length > 0);
      } catch (error) {
        console.warn("Checklist fetch failed:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [model, site, group]);

  if (loading || !hasChecklists) {
    return "-";
  }

  const handleClick = (event) => {
    event.stopPropagation();
    if (REPOSITORY_URL) {
      window.open(`${REPOSITORY_URL}/equipmentList/${inventoryId}?action=documentation`, "_blank");
    }
  };

  return (
    <div style={{ display: "flex", height: "100%" }}>
      <button
        onClick={handleClick}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 0,
          display: "inline-flex",
          alignItems: "center",
        }}
        title={`View documentation for ${model}`}
      >
        <ChecklistFolder />
      </button>
    </div>
  );
};

export default ChecklistRender;
